import theme from './theme.regent';

export default theme;
